import api from './api';

const animalSalesService = {
  // Get all animal sales
  getAllSales: async () => {
    const response = await api.get('/api/animal-sales');
    return response.data;
  },

  // Get animal sale by ID
  getSaleById: async (id) => {
    const response = await api.get(`/api/animal-sales/${id}`);
    return response.data;
  },

  // Get available animals for sale
  getAvailableAnimals: async () => {
    const response = await api.get('/api/animal-sales/available');
    return response.data;
  },

  // Create animal sale
  createSale: async (saleData) => {
    const response = await api.post('/api/animal-sales', saleData);
    return response.data;
  },

  // Update animal sale
  updateSale: async (id, saleData) => {
    const response = await api.put(`/api/animal-sales/${id}`, saleData);
    return response.data;
  },

  // Delete animal sale
  deleteSale: async (id) => {
    const response = await api.delete(`/api/animal-sales/${id}`);
    return response.data;
  },

  // Get animal sales statistics
  getStats: async () => {
    const response = await api.get('/api/animal-sales/stats');
    return response.data;
  },
};

export default animalSalesService;